/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OpportunityDataWindow
 */
export interface OpportunityDataWindow {
  /**
   *
   * @type {string}
   * @memberof OpportunityDataWindow
   */
  fromDate: string;
  /**
   *
   * @type {string}
   * @memberof OpportunityDataWindow
   */
  toDate: string;
  /**
   *
   * @type {number}
   * @memberof OpportunityDataWindow
   */
  shipmentCount: number;
}

/**
 * Check if a given object implements the OpportunityDataWindow interface.
 */
export function instanceOfOpportunityDataWindow(
  value: object,
): value is OpportunityDataWindow {
  if (!("fromDate" in value) || value["fromDate"] === undefined) return false;
  if (!("toDate" in value) || value["toDate"] === undefined) return false;
  if (!("shipmentCount" in value) || value["shipmentCount"] === undefined)
    return false;
  return true;
}

export function OpportunityDataWindowFromJSON(
  json: any,
): OpportunityDataWindow {
  return OpportunityDataWindowFromJSONTyped(json, false);
}

export function OpportunityDataWindowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityDataWindow {
  if (json == null) {
    return json;
  }
  return {
    fromDate: json["fromDate"],
    toDate: json["toDate"],
    shipmentCount: json["shipmentCount"],
  };
}

export function OpportunityDataWindowToJSON(json: any): OpportunityDataWindow {
  return OpportunityDataWindowToJSONTyped(json, false);
}

export function OpportunityDataWindowToJSONTyped(
  value?: OpportunityDataWindow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fromDate: value["fromDate"],
    toDate: value["toDate"],
    shipmentCount: value["shipmentCount"],
  };
}
